module.exports = __webpack_public_path__ + "static/media/power-atk2.398f1093.png";